import { useEffect } from 'react';
import { forEach } from 'lodash';

export default (fields, register) => {
  useEffect(() => {
    forEach(fields, (field) => {
      register({ name: field });
    });
  }, [fields, register]);
};
